export function disableScroll() {
  	var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  	document.body.style.overflow = "hidden";
}

export function enableScroll() {
    window.onscroll = function () { };
    document.body.style.removeProperty('overflow');
}

export function requiredFieldsEvents(fields) {
	fields.forEach(item => {
		if (item.tagName == "INPUT" || item.tagName == "TEXTAREA") {
			item.classList.remove('invalid');

			if (item.type == "checkbox" || item.type == "radio") {
				item.onchange = () => {
					validateFields(fields);
				}
			}

			else {
				item.oninput = () => {
					validateFields(fields);
				}
			}
		}
		else {
			const inputs = item.querySelectorAll('input');
			const datepicker = item.querySelector('.js-datepicker-input');

			inputs.forEach(input => {
				input.onchange = () => {
					validateFields(fields);
				}
			})

			if (datepicker) {
				// datepicker.js
			}
		}
	})
}

export function validateFields(fields) {

	var error = false;

	requiredFieldsEvents(fields);

	fields.forEach(item => {
		if (item.tagName == "INPUT" || item.tagName == "TEXTAREA") {
			item.classList.remove('invalid');

			if (item.type == "checkbox" || item.type == "radio") {
				if (!item.checked) {
					item.classList.add('invalid');
					error = true;
				}
			}

			else if (item.type == "email") {
				var regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

				if (!item.value.match(regex)) {
					item.classList.add('invalid');
					error = true;
				}
			}

			else if (item.type == "tel") {
				var testValue = item.value;
				testValue = testValue.replace(/\s+/g, '');

				var regex = /^\d{9,15}$/;

				if (!testValue.match(regex)) {
					item.classList.add('invalid');
					error = true;
				}
			}

			else if (item.tagName == "TEXTAREA") {
				if (item.value.length <= 0 || item.value.length > 600) {
					item.classList.add('invalid');
					error = true;
				}
			}

			else {
				if (item.value.length <= 0) {
					item.classList.add('invalid');
					error = true;
				}
			}
		}

		else {
			const checked = item.querySelectorAll('input:checked');
			const recaptcha = item.querySelector('.g-recaptcha');
			const datepicker = item.querySelector('.js-datepicker-input');
			
			if (datepicker) {
				item.classList.remove('invalid');

				if (datepicker.value.length <= 0) {
					item.classList.add('invalid');
					error = true;
				}
			}

			else if (recaptcha) {
				item.classList.remove('invalid');

				// var response = grecaptcha.getResponse();
				// if (response.length <= 0) {
				// 	item.classList.add('invalid');
				// 	error = true;
				// }
			}

			else {
				item.classList[checked.length <= 0 ? 'add' : 'remove']('invalid');

				if (checked.length <= 0) {
					error = true;
				}
			}
		}
	})

	return error;
}